module.exports = "/_next/static/images/22811bf51dddbe926759ce9054371897-warning_circle.svg.webp";